/**
 * Enum for heading field size.
 * @readonly
 * @enum {string}
 */
export const HeadingFieldSize = Object.freeze({
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
})
